/* ----- header ----- */
class Header {
  constructor() {
    this.desktopBp = window.matchMedia(`(min-width: ${window.breakpoints.desktop})`);
    this.els();
    this.listeners();
    document.querySelector('.desktop-nav.no-js').classList.remove('no-js');
  }

  els() {
    this.desktopNav = document.querySelector('.desktop-nav');
    this.linksItems = document.querySelectorAll('.links__item > a, .links__item > button, .desktop-nav .dropdown');
    this.imageHoverTargets = document.querySelectorAll('[data-image-hover-target]');
    this.topNavButtons = document.querySelectorAll('.links__item > button');
  }

  listeners() {
    this.linksItems.forEach((item) => {
      item.addEventListener('mouseenter', (e) => {
        this.desktopNav.classList.add('is-hovered');
        item.closest('.links__item').classList.add('hover');
      });

      item.addEventListener('mouseleave', (e) => {
        this.desktopNav.classList.remove('is-hovered');
        item.closest('.links__item').classList.remove('hover');
      });
    });

    this.imageHoverTargets.forEach((target) => {
      target.addEventListener('mouseenter', (e) => {
        const container = e.target.closest('[data-image-hover-container]');
				const target = e.target.getAttribute('data-image-hover-target');
				const hover = container.querySelector(`[data-image-hover="${target}"]`);
				const image = container.querySelector('[data-image]');
				if (hover) hover.classList.add('active');
				if (image) image.classList.add('hide');
      });

      target.addEventListener('mouseleave', (e) => {
        const container = e.target.closest('[data-image-hover-container]');
				const target = e.target.getAttribute('data-image-hover-target');
				const hover = container.querySelector(`[data-image-hover="${target}"]`);
				const image = container.querySelector('[data-image]');
				if (hover) hover.classList.remove('active');
				if (image) image.classList.remove('hide');
      });
    });

    this.topNavButtons.forEach((button) => {
      button.addEventListener('click', (e) => {
        e.currentTarget.blur();
      });
    });
  }
}

new Header()

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.limitedUpdate = this.hasAttribute('data-limited-update') && this.dataset.limitedUpdate === 'true';
  }

  connectedCallback() {
    const nonSwatchVs = this.querySelectorAll('[data-variant-id]:not([data-swatch])');
    this.isMultiVariants = nonSwatchVs?.length > 1;
  }

  onVariantChange() {
    if (!this.isMultiVariants) return;

    this.updateOptions();
    this.updateMasterId();
    this.updateAffirm();

    if (!this.limitedUpdate) {
      this.toggleAddButton(true, '', false);
      // this.updatePickupAvailability();
    }

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      /* if (!this.limitedUpdate) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } */
    } else {
      /* this.updateMedia(); */
      this.updateOptionsLegend();
      this.updateVariantInput();
      this.renderProductInfo();

      if (!this.limitedUpdate) {
        this.updateSku();
        this.updateURL();
        /* this.renderProductInfo(); */
      } else {
        this.updateSetInputs();
      }
    }
  }

  updateAffirm() {
    if (!window.affirm) return;

    const affirmWidgets = document.querySelectorAll('[data-product-affirm]');
    affirmWidgets.forEach(affirmWidget => {
      affirmWidget.setAttribute('data-amount', this.currentVariant.price);
    });
    affirm.ui?.refresh();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateOptionsLegend() {
    this.currentVariant.options.forEach((option, index) => {
      const replaceText = this.getOptionNameReplaceText() && this.getOptionNameReplaceText().find(o => option === o.title);
      const el = this.querySelector(`[data-product-option-active="${index}"]`);
      el ? el.innerText = replaceText ? replaceText.replace : option : null;
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if (!this.currentVariant) return;

    window.publish(PUB_SUB_EVENTS.variantChange, {
      sectionId: this.dataset.section,
      currentVariant: this.currentVariant,
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => { parent.scroll(0, 0) });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateSku() {
    if (!(this.currentVariant && document.getElementById('productSku'))) return;
    productSku.innerText = 'SKU: ' + this.currentVariant.sku;
    if (!(this.currentVariant && document.getElementById('productStickySku'))) return;
    productStickySku.innerText = 'SKU: ' + this.currentVariant.sku;
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment, #product-form-sticky`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateStickyATC(html) {
    const mediaDestination = document.getElementById('productStickyMedia');
    const mediaSource = html.getElementById('productStickyMedia');
    const priceDestination = document.getElementById('productStickyPrice');
    const priceSource = html.getElementById('productStickyPrice');
    const titleDestination = document.getElementById('pdpStickyTitle');
    const titleSource = html.getElementById('pdpStickyTitle');
    const yotpoDestination = document.getElementById('productStickyYotpo');
    const yotpoSource = html.getElementById('productStickyYotpo');
    const atcDestination = document.getElementById('productStickyATC');
    const atcSource = html.getElementById('productStickyATC');

    if (mediaSource && mediaDestination) mediaDestination.innerHTML = mediaSource.innerHTML;
    if (priceSource && priceDestination) priceDestination.innerHTML = priceSource.innerHTML;
    if (titleSource && titleDestination) titleDestination.innerHTML = titleSource.innerHTML;
    if (yotpoSource && yotpoDestination) yotpoDestination.setAttribute('data-yotpo-product-id', yotpoSource.getAttribute('data-yotpo-product-id'));
    if (atcSource && atcDestination) atcDestination.innerHTML = atcSource.innerHTML;

    document.getElementById('productStickyPrice')?.classList.remove('visibility-hidden');
  }

  renderProductInfo() {
    const sectionId = this.dataset.section;
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${sectionId}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(id);
        const yotpoDestination = document.getElementById('productYotpo');
        const yotpoSource = html.getElementById('productYotpo');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (yotpoSource && yotpoDestination) yotpoDestination.setAttribute('data-yotpo-product-id', yotpoSource.getAttribute('data-yotpo-product-id'));

        document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut || 'Out of stock');
        this.updateStickyATC(html);
      });
  }

  toggleAddButton() {
    const addButtons = document.querySelectorAll(`#product-form-${this.dataset.section} [name="add"], sticky-form [data-product-add-to-cart]`);
    const bisButton = this.closest('.pdp__info-container').querySelector('.product__bis');
    const qtyButtons = document.querySelectorAll('[data-pdp-form-block].bis-enabled .product-form__quantity, [data-pdp-form-block].bis-enabled .product-form__quantity-desktop');

    addButtons.forEach(el => {
      if (this.currentVariant.available) {
        el.removeAttribute('disabled');
        el.classList.remove('hide');
      } else {
        el.setAttribute('disabled', true);
        if (bisButton) el.classList.add('hide');
      }

      let atcText = this.currentVariant.available ? `${window.variantStrings.addToCart} — ${window.Shopify.formatMoney(this.currentVariant.price, window.theme.moneyFormat || '${{amount}}').replace('.00', '')}` : window.variantStrings.soldOut;
      if (typeof window.productType !== 'undefined' && window.productType == 'in store only') atcText = window.variantStrings.inStoreOnly;
      el.textContent = atcText;

      if (!this.currentVariant.available) {
        bisButton?.classList.remove('hide');
      } else {
        bisButton?.classList.add('hide');
      }
    });

    qtyButtons.forEach(el => {
      if (this.currentVariant.available) {
        el.classList.remove('hide');
      } else {
        el.classList.add('hide');
      }
    });
  }

  setUnavailable() {
    const addButton = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.section}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"][data-json="product-variants"]').textContent);
    return this.variantData;
  }

  getOptionNameReplaceText() {
    this.optionNameReplaceText = this.optionNameReplaceText || JSON.parse(this.querySelector('[type="application/json"][data-json="option-name-replace-text"]').textContent);
    return this.optionNameReplaceText;
  }

  updateSetInputs() {
    this.querySelectorAll(':checked').forEach(input => {
      const setInput = document.querySelector(`input[data-form-id="${input.getAttribute('form')}"][name$="id"]`);
      if (setInput) setInput.value = this.currentVariant.id;
    });
  }
};

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      const inputs = Array.from(fieldset.querySelectorAll('input'));
      return inputs.length === 1 ? inputs[0].value : inputs.length && inputs.find((radio) => radio.checked).value;
    });
  }
};

customElements.define('variant-radios', VariantRadios);

/* formatMoney from slate base files */
window.Shopify = window.Shopify || {};
window.Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  let value = '';
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = (format || "${{amount}}");

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    let parts   = number.split('.');
    let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    let cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/* ----- globals ----- */
function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function getFocusableElements(container) {
  const isMobile = window.matchMedia('(max-width: 1023px)').matches;
  const notEl = isMobile ? '.hide-mobile' : '.hide-desktop';
  return Array.from(
    container.querySelectorAll(
      `summary:not(${notEl}), a[href]:not(${notEl}), button:enabled:not(${notEl}), [tabindex]:not([tabindex^='-']):not(${notEl}), [draggable]:not(${notEl}), area:not(${notEl}), input:not([type=hidden]):enabled:not(${notEl}), select:enabled:not(${notEl}), textarea:enabled:not(${notEl}), object:not(${notEl}), iframe:not(${notEl})`
    )
  );
}

/* Don't change this */
function lockScrollEnable() {
  document.body.style.overflow = 'hidden';
}

/* Don't change this */
function lockScrollDisable() {
  document.body.style.overflow = null;
}

subscribe(PUB_SUB_EVENTS.cartUpdate, e => {
  if (e.source === 'product-form') return;
  cartObj = e.cartData;
});

function loadMinicart() {
  fetch(`${window.Shopify.routes.root}?sections=cart-drawer`)
    .then(response => response.json())
    .then(data => {
      document.querySelector('#cartDrawerInner').innerHTML = (new DOMParser().parseFromString(data['cart-drawer'], 'text/html').querySelector('#cartDrawerInner').innerHTML);

      const hasUpsells = document.querySelector('#cartDrawerInner [data-swiper]') !== null;

      if (hasUpsells) {
        if (typeof window.loadSwiper === 'function') {
          window.loadSwiper();
        } else if (typeof window.swipers === 'function') {
          window.swipers();
        }
      }

      setTimeout(() => {
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            window.cartObj = cart;
            if (hasUpsells) window.removeCartItemsFromUpsell(cart);
          })
          .catch(error => console.error('Error fetching cart:', error));
      }, 100);
    })
}

document.addEventListener('change', (e) => {
  if (e.target.matches('[data-handwritten-card-checkbox]')) {
    const parent = document.querySelector('[data-handwritten-card]');
    const variantId = parent.getAttribute('data-handwritten-card');

    if (e.target.checked) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          quantity: 1,
          id: Number(variantId)
        })
      })
        .then((response) => response.json())
        .then((res) => {
          loadMinicart();
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          quantity: 0,
          id: variantId
        }),
      })
      .then(response => response.json())
      .then((res) => {
        loadMinicart();
      })
      .catch((e) => {
        console.error(e);
      });
    }
  }
});

const watchDrawers = () => {
  document.querySelectorAll('[id^="Details-"] summary:not([data-watched])').forEach((summary) => {
    summary.setAttribute('data-watched', 'true');
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    summary.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });
  });
};

watchDrawers();
subscribe(PUB_SUB_EVENTS.cartUpdate, e => {
  watchDrawers();
});


const trapFocusHandlers = {};

// function trapFocus(container, elementToFocus = container) {
window.trapFocus = options => {
  let { container, elements = null, elementToFocus = null } = options;
  elementToFocus = elementToFocus || container
  elements = elements || getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; /* If not TAB key */
    /* On the last focusable element and tab forward, focus the first element. */
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    /*  On the first focusable element and tab backward, focus the last element. */
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');

        if (!this.form) return;

        const idInput = this.form.querySelector('[name=id]');
        if (idInput) idInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton?.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton && this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        if (this.submitButton) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
        }
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              // Shopify drops the sections response on non-200 responses, so we need to re-request and display them
              if(response.status === 422 && config.body.has('sections')) {
                const sections = config.body.get('sections');
                fetch(`/?sections=${sections}`)
                  .then(response => response.json())
                  .then(data => {
                    data.sections = data;
                    this.cart.renderContents(data);
                  });
              }

              const soldOutMessage = this.submitButton && this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              fetch(`${routes.cart_url}.js`)
                .then(response => response.json())
                .then(data => {
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form-cart-total',
                    cartData: data,
                  });
                });


              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            this.cart.renderContents(response);
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            if (this.submitButton) this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error && this.submitButton) this.submitButton.removeAttribute('aria-disabled');
            this.closest('.quickadd--loading')?.classList.remove('quickadd--loading');
            this.querySelector('.loading__spinner')?.classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

const onScroll = () => {
  if (window.menuToggling) return;


  if (window.pageYOffset > window.headerScrolledThreshold) {
    document.documentElement.classList.add('header--scrolled');
  } else {
    document.documentElement.classList.remove('header--scrolled');
  }

  if (window.pageYOffset > 300 + window.headerScrolledThreshold) {
    document.documentElement.classList.add('header--scrolled--after');
  } else {
    document.documentElement.classList.remove('header--scrolled--after');
  }

  const scrollTop = window.pageYOffset;

  /* scroll direction */
  window.scrollDirection = scrollTop > lastScrollTop ? 'down' : 'up';
  document.documentElement.dataset.scrollDirection = window.scrollDirection;
  lastScrollTop = window.pageYOffset;
};

const inViewVideo = (el, src) => {
  const $video = el.closest('video');

  if (!$video) return;
  if (typeof src !== 'undefined') $video.src = el.dataset.inViewVideoSrc;

  if (!$video.hasAttribute('data-autoplay')) return;
  /* $video.removeAttribute('controls'); */
  $video.play();
};

window.lazyLoadScript = obj => {
  const isLoaded = document.head.querySelector(`[data-in-view-script-name*='${obj.src}']`);
  const cb = obj.callback && typeof window[obj.callback] === 'function' ? window[obj.callback] : null;

  if (isLoaded) {
    if (cb) cb();
    return;
  }

  if (!obj.hasOwnProperty('src')) {
    // only need to fire the callback, no script to load
    if (cb) cb();
    return;
  }

  const el = document.createElement('script');
  el.dataset.inViewScriptName = obj.src;
  el.type = obj.type || 'text/javascript';
  if (obj.defer) el.defer = true;
  else if (obj.async) el.async = true;
  el.src = obj.src;
  document.head.appendChild(el);

  if (cb) el.onload = requestAnimationFrame(() => {
    cb()
  });
}

const inViewScript = obj => {
  lazyLoadScript(obj);
};

window.loadSwiper = () => {
  /* load swiper if needed */
  if (!window.swiperLoaded && typeof Swiper !== 'function') {
    const $script = document.createElement('script');
    $script.async = true;
    $script.src = window.assetUrls['swiper.js'];
    document.head.appendChild($script);
    window.swiperLoaded = true
  }

  const swiperIsReady = new Promise(resolve => {
    let timer = setInterval(() => {
      if (typeof Swiper === 'function') {
        clearInterval(timer);
        return resolve();
      }
    }, 30)
  });

  swiperIsReady.then(() => {
    window.swipers();
  }).catch(error => {
    console.error('Something went wrong', error);
  })
};

window.buildQuickAdd = (el, variants)  => {
  const quickaddEl = el.querySelector('[data-product-card-quickadd]');
  if (!quickaddEl) return;

  quickaddEl.innerHTML = '';
  let els = [];
  variants.forEach(variant => {
    const button = document.createElement('button');
    const span = document.createElement('span');
    const title = variant.available ? `Add ${variant.name} to cart` : `${variant.name} is out of stock`;
    button.type = 'button';
    if (!variant.available) button.setAttribute('disabled', 'disabled');
    button.classList = 'product-card__quickadd-btn';
    button.setAttribute('data-quickadd-variant', '');
    button.setAttribute('aria-label', title);
    button.setAttribute('title', title);
    button.setAttribute('onclick', `window.onQuickAdd(event.target, ${variant.id})`);
    span.setAttribute('aria-hidden', true);
    span.innerText = variant.title.split('/ ')[1].replace(/&#39;/g , "\'");
    button.appendChild(span);
    els.push(button);
    quickaddEl.appendChild(button);
  });
};

window.onQuickAdd = (el, variant) => {
  el.closest('.product-card').classList.add('quickadd--loading');
  const $form = el.closest('form');
  const id = $form.querySelector('[name="id"]');
  id.value = variant;
  el.closest('form').dispatchEvent(new Event('submit', { bubbles: true }));
  /* window.addToCart($form); */
};

/* product-card: update card on swatch click */
window.onSwatchClick = e  => {
  if (e.target.classList.contains('swatches__item--active')) return;

  e.preventDefault();

  const alreadyClicked = e.target.classList.contains('clicked');
  const data = JSON.parse(e.target.dataset.swatch);
  let img;

  /* make request for image */
  if (!alreadyClicked) {
    img = new Image();
    img.src = data.images[0].src;
    e.target.classList.add('clicked');
  }

  const $card = e.target.closest('[data-product-card]');

  /* build swatches */
  buildQuickAdd($card, data.variants);

  /* loading state: begin */
  $card.classList.add('product-card--loading');

  /* swatch active class: remove previous */
  $card.querySelector('.swatches__item--active')?.classList.remove('swatches__item--active');

  /* swatch active class: add to clicked swatch */
  e.target.classList.add('swatches__item--active');

  /*
    update card via swatch data
  */

  /* update card: image */
  $card.querySelectorAll('[data-product-card-image]').forEach((el, index) => {
    const $src = el.querySelector('[data-product-card-image-src]');
    const $srcset = el.querySelector('[data-product-card-image-srcset]');
    $src.alt = data.images[index].alt;
    $src.src = data.images[index].src;
    $src.srcset = data.images[index].srcset;
    $srcset.srcset = data.images[index].srcsetLarge;
  });

  /* update card: url */
  const $url = $card.querySelector('[data-product-card-url]');
  $url.href = data.url;

  /* update card: url title attribute */
  $url.title = `View ${data.title} in ${data.variantName} product details`;

  /* update card: price */
  if (data.priceCompareAtAmount > data.priceAmount) {
    $card.querySelector('[data-product-card-price-compare]').innerHTML = data.priceCompareAt;
    $card.querySelector('[data-product-card-price-regular]').innerHTML = data.price;
  } else {
    $card.querySelector('[data-product-card-price-compare]').innerHTML = '';
    $card.querySelector('[data-product-card-price-regular]').innerHTML = data.price;
  }

  /* update card: title */
  $card.querySelector('[data-product-card-title]').innerText = data.title.replace(/&lt;br&gt;/g, "\n").replace(/&#39;/g , "\'");

  /* update card: variant name */
  $card.querySelector('[data-product-card-variant-name]').innerText = data.variantName;

  /* loading state: end */
  if (alreadyClicked) {
    setTimeout(() => {
      $card.classList.remove('product-card--loading');
    }, 200);
  } else {
    img.onload = () => {
      setTimeout(() => {
        $card.classList.remove('product-card--loading');
      }, 200);
    }
  }
};

window.publishProductsData = data => {
  window.dispatchEvent(new CustomEvent('publishProductsData', {
    detail: data,
  }));
};

/* swipers init via data-swiper={options} */

window.swiperEls = [];

window.swipers = () => {
  document.querySelectorAll('[data-swiper]:not(.swiper-initialized)').forEach((el, index) => {
    el.dataset.swiperIndex = index;
    const changeEvent = el.getAttribute('data-swiper-slide-change');
    const data = JSON.parse(el.dataset.swiper);
    const isNumberedPagination = el.hasAttribute('data-numbered-pagination');

    const renderNumbers = swiper => {
      const paginationEls = swiper.pagination?.el?.querySelectorAll('span.swiper-pagination-bullet');
      paginationEls?.forEach((el, bulletIndex) => {
        if (bulletIndex >= swiper.pagination.bullets.length) return;

        el.setAttribute('role', 'button');
        el.setAttribute('aria-label', `Go to slide ${bulletIndex + 1}`);

        if (isNumberedPagination && el.innerHTML === '') {
          el.innerHTML = bulletIndex + 1;
        }
      });
    };

    if (isNumberedPagination) {
      data.pagination.renderBullet = function (i, className) {
        return `<span class="${className}">${(i + 1)}</span>`;
      }
    }

    window.swiperEls[index] = new Swiper(el, Object.assign({}, {
      a11y: true,
      observer: true,
      observeParents: true,
      slidesPerView: 'auto',
      threshold: 8,
      watchSlidesProgress: true,
      on: {
        breakpoint: function (swiper, breakpointParams) {
          setTimeout(() => {
            /* console.log('swiper', swiper) */
            renderNumbers(swiper);
          }, 50);
        },

        slideChange: function (swiper) {
          if (changeEvent && window.hasOwnProperty(changeEvent) && typeof window[changeEvent] === 'function') {
            window[changeEvent](swiper);
          }

          setTimeout(() => {
            if (isNumberedPagination) {
              const paginationEls = swiper.pagination?.el?.querySelectorAll('.swiper-pagination-bullet');
              paginationEls.forEach((el, bulletIndex) => {
                el.classList.toggle('swiper-pagination-bullet-active', bulletIndex === swiper.realIndex);
                if (bulletIndex === swiper.realIndex) {
                  el.setAttribute('aria-current', 'true');
                } else if (el.hasAttribute('aria-current')) {
                  el.removeAttribute('aria-current');
                }
              })
            }
          }, 50);
        },

        init: function (swiper) {
          setTimeout(() => {
            if (isNumberedPagination) {
              renderNumbers(swiper);
            }
          }, 50);
        },
      },
    }, data));

    const initEvent = el.getAttribute('data-swiper-init');
    if (initEvent && window.hasOwnProperty(initEvent) && typeof window[initEvent] === 'function') {
      window.swiperEls[index].on('afterInit', function(e) {
        window[initEvent](e);
      });
      window.swiperEls[index].init();
    }
  });
};

window.inView = () => {
  /* add .in-view class to [data-in-view] els as they enter the viewport */
  const inViewEls = document.querySelectorAll('[data-in-view]');

  const inViewObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');

        if (entry.target.hasAttribute('data-autoplay') || entry.target.hasAttribute('data-in-view-video-src')) {
          inViewVideo(entry.target, entry.target.dataset.inViewVideoSrc);
        }

        if (entry.target.hasAttribute('data-in-view-swiper')) {
          loadSwiper();
          inViewObserver.unobserve(entry.target);
        }

        if (entry.target.hasAttribute('data-in-view-script')) {
          inViewScript(JSON.parse(entry.target.dataset.inViewScript));
        }
      } else {
        if (entry.target.hasAttribute('data-autoplay') && entry.target.paused == false) {
          entry.target.pause()
        }
      }
    });
  });

  inViewEls.forEach(el => inViewObserver.observe(el));
};

document.addEventListener('DOMContentLoaded', () => {
  window.lastScrollTop = window.pageYOffset;

  onScroll();
  inView();

  window.addEventListener('scroll', () => {
    onScroll();
  }, { passive: true });
});

window.addEventListener('keyup', e => {
  if (e.key === 'Escape') {
    document.dispatchEvent(new CustomEvent('onEsc'));
    const expandedCards = document.querySelectorAll('[data-product-card].show-quickadd');
    expandedCards.forEach(card => {
      card.classList.remove('show-quickadd');
      const actionBtn = card.querySelector('[data-quickadd-action-btn]');
      if (actionBtn) {
        actionBtn.setAttribute('aria-expanded', 'false');
        actionBtn.focus();
      }
    });
  }
});

window.toggleAccessibility = () => {
  document.querySelectorAll('[data-toggle]').forEach((el) => {
    const toggleData = el.getAttribute('data-toggle');
    const container = el.closest(`:has(${toggleData})`);
    const toggleMaxWidth = el.hasAttribute('data-toggle-max-width') ? el.getAttribute('data-toggle-max-width') : null;
    const className = toggleData.includes('>') ? `:scope ${toggleData}` : toggleData;
    const target = container.querySelector(className);

    if (!target) return;

    if (toggleMaxWidth !== null && !window.matchMedia(`(min-width: ${toggleMaxWidth}px)`).matches) {
      el.removeAttribute('aria-expanded');
      target.removeAttribute('aria-hidden');
    } else {
      if (container.classList.contains('active-toggle')) {
        el.setAttribute('aria-expanded', 'true');
        target.setAttribute('aria-hidden', 'false');
      } else {
        el.setAttribute('aria-expanded', 'false');
        target.setAttribute('aria-hidden', 'true');
      }
    }
  });
};

window.toggleAccessibility();

window.widthLast = window.outerWidth;
window.addEventListener('resize', window.debounce(() => {
  const windowWidth = window.outerWidth;
  if (window.widthLast !== windowWidth) {
    document.dispatchEvent(new CustomEvent('resizeEnded'));
    window.widthLast = windowWidth;
    window.toggleAccessibility();
  }
}, 300), { passive: true });

const dataToggle = (e) => {
  const toggleData = e.getAttribute('data-toggle');
  const container = e.closest(`:has(${toggleData})`);
  const className = toggleData.includes('>') ? `:scope ${toggleData}` : toggleData;
  const target = container.querySelector(className);
  const toggleStyle = e.hasAttribute('data-toggle-style') ? e.getAttribute('data-toggle-style') : 'block';

  if (!target) return;

  container.classList.toggle('active-toggle');
  if (target.style.display === 'none') target.style.display = toggleStyle;
  else target.style.display = 'none';
  window.toggleAccessibility();
};

document.addEventListener('click', (e) => {
  if (e.target.matches('[data-toggle]')) {
    const el = e.target;
    const toggleMaxWidth = el.hasAttribute('data-toggle-max-width') ? el.getAttribute('data-toggle-max-width') : null;
    if ((toggleMaxWidth !== null && !window.matchMedia(`(min-width: ${toggleMaxWidth}px)`).matches) || toggleMaxWidth === null) {
      e.preventDefault();
      dataToggle(el);
    }
  }
});

document.addEventListener('click', (e) => {
  if (e.target.matches('[data-toggle-class]')) {
    e.preventDefault();
    const el = e.target;
    const className = el.getAttribute('data-toggle-class');
    const target = el.hasAttribute('data-toggle-class-on') ? document.querySelector(el.getAttribute('data-toggle-class-on')) : document.documentElement;
    target.classList.toggle(className);
  }
});

document.addEventListener('click', (e) => {
  if (e.target.matches('[data-toggle-transition]')) {
    e.preventDefault();
    const el = e.target;
    const transitionName = JSON.parse(el.getAttribute('data-toggle-transition')).class;
    const duration = JSON.parse(el.getAttribute('data-toggle-transition')).duration;
    const target = el.hasAttribute('data-toggle-class-on') ? document.querySelector(el.getAttribute('data-toggle-class-on')) : document.documentElement;
    target.classList.toggle(transitionName);
    setTimeout(() => {
      target.classList.remove(transitionName);
    }, duration);
  }
});


subscribe(PUB_SUB_EVENTS.cartRegistryCheck, e => {
  fetch('/?sections=registry-mixed-modal')
    .then(response => response.json())
    .then(data => {
      const html = new DOMParser().parseFromString(data['registry-mixed-modal'], 'text/html').body.firstChild;
      html.querySelectorAll('[data-vanilla-modal]').forEach(el => el.classList.add('vanilla-modal'));
      document.body.appendChild(html);
      html.querySelectorAll('[data-close-open-cart]')?.forEach(el => {
        el.addEventListener('click', () => {
          publish(PUB_SUB_EVENTS.cartRegistryChecked, {eventId: e.eventId, accepted: false});
          window.location.href = `/checkout?skip_shop_pay=true${window.registryCode ? `&discount=${window.registryCode}` : ''}`;
          html.remove();
        });
      });
      html.querySelectorAll('[data-clear-and-add]')?.forEach(el => {
        el.addEventListener('click', () => {
          const headers = {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json',
          };
          fetch(`${routes.cart_clear_url}`, { method: 'POST', headers })
            .then(response => response.json())
            .then(data => {
              const formData = new FormData();
              Object.keys(data.attributes).forEach(attr => {
                formData.append(`attributes[${attr}]`, '');
              });
              fetch(`${routes.cart_update_url}`, {
                method: 'POST',
                headers,
                body: formData,
              })
                .then(response => response.json())
                .then(cartData => {
                  html.remove();
                  publish(PUB_SUB_EVENTS.cartRegistryChecked, {eventId: e.eventId, accepted: true});
                })
                .catch(error => {
                  console.error('Error fetching updated cart:', error);
                  publish(PUB_SUB_EVENTS.cartRegistryChecked, {eventId: e.eventId, accepted: false});
                  html.remove();
                });
            })
            .catch(error => {
              console.error('Error clearing cart:', error);
              publish(PUB_SUB_EVENTS.cartRegistryChecked, {eventId: e.eventId, accepted: false});
              html.remove();
            });
        });
      });
      html.querySelectorAll('[data-close]')?.forEach(el => {
        el.addEventListener('click', () => {
          publish(PUB_SUB_EVENTS.cartRegistryChecked, {eventId: e.eventId, accepted: false});
          html.remove();
        });
      });
    });
});

const scrollToHash = () => {
  if (!window.location.hash) return;
  const mediaQuery = window.matchMedia('(min-width: 1024px)');
  const offset = mediaQuery.matches ? 97 : 70;
  const hash = window.location.hash.slice(1);
  const targetElement = document.querySelector(`[data-anchor="${hash}"]`);

  if (targetElement) {
    const elementPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - offset;
    const details = targetElement.querySelector('details.accordion');

    if (details) details.open = true;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  }
};

document.addEventListener('DOMContentLoaded', () => {
  scrollToHash();
});

window.addEventListener('hashchange', scrollToHash);

(function() {
  /* Delete cart cookie on logout */
  if(routes?.account_logout_url) {
    const logoutLinks = document.querySelectorAll(`a[href^="${routes.account_logout_url}"]`);
    logoutLinks?.forEach(link => {
      link.addEventListener('click', () => {
        document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      });
    });
  }
  /* Restore images from Accessiby injections */
  const observerImages = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.target.tagName === 'IMG') {
        const img = mutation.target;
        if (img.hasAttribute('role')) {
          img.removeAttribute('role');
        }
      }
    }
  });
  observerImages.observe(document.body, { attributes: true, attributeOldValue: true, subtree: true });
  /* ADA adjust type attribute from all script tags */
  document.querySelectorAll('script').forEach(script => {
    if (script.hasAttribute('type') && script.getAttribute('type') == 'text/javascript') {
      script.removeAttribute('type');
    }
    if (script.hasAttribute('type') && script.getAttribute('type') == 'module' && script.hasAttribute('defer')) {
      script.removeAttribute('defer');
    }
    if (script.hasAttribute('charset') && script.getAttribute('charset') == '') {
      script.removeAttribute('charset');
    }
  });
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName.toLowerCase() === 'script') {
            if (node.hasAttribute('type') && node.getAttribute('type') == 'text/javascript') {
              node.removeAttribute('type');
            }
            if (node.hasAttribute('type') && node.getAttribute('type') == 'module' && node.hasAttribute('defer')) {
              node.removeAttribute('defer');
            }
            if (node.hasAttribute('charset') && node.getAttribute('charset') == '') {
              node.removeAttribute('charset');
            }
          }
          if (node.nodeType === Node.ELEMENT_NODE) {
            node.querySelectorAll('script').forEach(nestedScript => {
              if (nestedScript.hasAttribute('type') && nestedScript.getAttribute('type') == 'text/javascript') {
                nestedScript.removeAttribute('type');
              }
              if (nestedScript.hasAttribute('type') && nestedScript.getAttribute('type') == 'module' && nestedScript.hasAttribute('defer')) {
                nestedScript.removeAttribute('defer');
              }
              if (nestedScript.hasAttribute('charset') && nestedScript.getAttribute('charset') == '') {
                nestedScript.removeAttribute('charset');
              }
            });
          }
        });
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  /* SEO/ADA link helper */
  const links = document.querySelectorAll('a');
  links.forEach(link => {
    if (link.textContent.toLowerCase().includes('learn more') && !link.querySelector('.sr-only') && link.href.includes('heath-clay-studio')) {
      const span = document.createElement('span');
      span.textContent = 'Learn more about Heath Clay Studio';
      span.classList.add('sr-only');
      link.append(span);
    }
  });
  const waitForOneTrust = (selector) => {
    return new Promise((resolve) => {
      const observer = new MutationObserver((mutations, observer) => {
        const element = document.querySelector(selector);
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
    });
  };
  waitForOneTrust('a[href*="giving-consent-to-cookies"]').then((link) => {
    const span = document.createElement('span');
    span.textContent = 'More information about your privacy, opens in a new tab';
    span.classList.add('sr-only');
    link.append(span);
  });
})();